<template>
    <div class="bg-info-subtle text-center px-1">
        <p class="small fw-bold mb-0" v-html="title" />
    </div>
</template>

<script>

export default {
    name: "OptionBanner",
    props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
